<template>
    <div>
        <div class="text-center">
            <h2>Georgia Ntatsi</h2>
        </div>
        <v-container class="main-text text-container">
            <div>
                <v-img :width="415" :height="415" style="float: left;" class="bradius" :src="require('@/assets/partners/Photo_Georgia_Ntatsi.jpg')" />
                <p class="cv-text">
                    Georgia Ntatsi is Assistant Professor at the Laboratory of Vegetable Production, Department of Crop Science, AUA. Dr. Ntatsi was awarded a Diploma in Agriculture from AUA, an MSc Diploma from the University of Ioannina and a Ph.D. degree from the Laboratory of Vegetable Production, AUA.  She has published 90 papers in refereed international scientific journals, 38 in congress proceedings (Acta Hort.), 4 as book chapters and more than 120 as abstracts in national and international conferences with 2.187 citations and an h-index 27. Dr. Ntatsi is specialized on vegetable production, plant nutrition, soil analyses, hydroponics, vegetable grafting, plant physiology, abiotic stress, fruit quality, biofortification, biostimulants, phytohormones, plant metabolism, organic production, vertical farming, greenhouse environment and its impact on vegetable production and quality. She has extensive experience in determination of inorganic nutrients in plant tissues and soil samples and quality parameters, greenhouse gases, biological nitrogen fixation and oxidation and antioxidant parameters of vegetables. She is an Associate Editor of Heliyon Agriculture (Elsevier), member of the Editorial Board in six international scientific journals with impact factor (Agronomy, Plants, Frontiers in Plant Science, Frontiers in Horticulture, Plant Stress and Scientific Reports) and Guest Editor in Agronomy, Biomolecules, Plants, Phyton and Frontiers in Plant Science. She is reviewer in many scientific journals, member of the International Society for Horticultural Science (ISHS) and member of the Greek Society for Horticultural Science (EEEO). In the last 5 years, Dr. Ntatsi has coordinated three research projects, one H2020 (RADIANT), one with Yara International and one national. She has been involved as researcher in five European research projects (LEGUME FUTURES, EUROLEGUME, ECONUTRI, TRUE and TOMRES) one PRIMA Proposal (VEGADAPT) 12 national research projects and was MC of two COST ACTION projects (FA1204 and CA11196).
                </p>
            </div>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {
        },
        data: () => ({
        }),
        computed: {
        }
    }
</script>
<style scoped>
.cv-card {
    border: 1px solid #D9D9D9;
    border-radius: 25px;
    text-align: center;
}
.bradius {
    border-radius: 25px;
    margin-right: 15px;
}
.cv-text {
    display: inline;
}
.main-text {
    width: 90%;
    max-width: 900px;
    margin: auto;
    color: #646464;
}

@media (max-width: 600px) {
    .bradius {
        float: none !important;
        display: block;
        margin: 0 auto 15px !important;
        max-width: 280px;
    }
}
</style>
